import { useSearchParams } from 'next/navigation';

import { sortProductsByOrder } from '@storefront/shared-components/modals/modal-printer-dynamic-comparison/modal-printer-dynamic-comparison-utils';
import { getProductDataFromProduct } from '@storefront/utils/prodRequests';

import { BundleProductWithLowestPrice } from '../app/pdp-config/printer/product-configuration/product-configuration.utils';
import { getSkuList } from '@storefront/app/pdp-config/printer/utils/utils';

export interface ProductImage {
  name: string;
  imgSrc: string;
}
export interface ProductSpecs {
  controlName: string;
  url: string;
  description: string;
}
export interface ProductInfo {
  id: string;
  sku: string;
  image: ProductImage;
  specs: ProductSpecs;
}
export interface ProductOptions {
  value: string;
  label: string;
}
export const formatProductInfo = (
  queryParamsSkus: any[],
  multipleProduct: any[]
) => {
  const unsortedProductsOptions: ProductOptions[] = [];
  const productsInfo: ProductInfo[] = [];
  const formatProductName = (name: string) => {
    const formattedName = name.replace(/hp /i, '').trim();
    const words = formattedName.split(' ');
    const pascalCaseWords = words
      .map(
        (word) =>
          `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`
      )
      .join('');
    return `${pascalCaseWords}Pdf`;
  };

  queryParamsSkus.forEach((sku: any) => {
    const product = multipleProduct.find((p) => p.sku === sku);
    const productInformation = getProductDataFromProduct(product);

    if (!productInformation) {
      return;
    }

    unsortedProductsOptions.push({
      value: sku,
      label: productInformation.hp_short_config_name,
    } as ProductOptions);

    productsInfo.push({
      sku: sku,
      id: sku,
      image: {
        name: productInformation.hp_short_config_name,
        imgSrc: productInformation.thumbnail_accessories?.url,
      },
      specs: {
        controlName: formatProductName(productInformation.hp_short_config_name),
        url: productInformation.hp_product_full_specification,
        description: '(PDF)',
      },
    } as ProductInfo);
  });

  const productOrder: string[] = [
    'hp envy photo',
    'hp smart tank',
    'hp officejet pro',
    'hp envy',
  ];

  const sortedProductsOptions = sortProductsByOrder(
    unsortedProductsOptions,
    productOrder
  );
  const productsOptions = sortedProductsOptions;

  return { productsOptions, productsInfo };
};

export const useProductsInfo = (
  multipleProduct: BundleProductWithLowestPrice[]
) => {
  const query = useSearchParams();
  const queryParamsSkus = getSkuList(query.get('skus'));

  return formatProductInfo(queryParamsSkus, multipleProduct);
};
export default useProductsInfo;
